import { atomFamily } from "jotai/utils";

import { VandalismSeverity } from "types/DigitalJourneySession";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

export const sessionVandalismSeverityAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`vandalismSeverity-${sessionId}`, null as VandalismSeverity | null)
);
export const vandalismSeverityAtom = createDerivedSessionAtom<VandalismSeverity | null>(sessionVandalismSeverityAtom);
